import { coreInitiativesIdMapSlice } from './update';

export const coreInitiativesIdMapReducers = coreInitiativesIdMapSlice.syncReducer;
